import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'CODE_ACCES',
  title: 'Comment générer un code d’accès pour mes appels d’offres ?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Rendez-vous dans l’onglet « Clients ».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CODE_ACCES/FR_CODE_ACCES_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur les 3 points en haut à droite'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CODE_ACCES/FR_CODE_ACCES_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliquez sur « Générer un code d’accès »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CODE_ACCES/FR_CODE_ACCES_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Renseignez les informations nécessaires'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CODE_ACCES/FR_CODE_ACCES_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Validez !'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CODE_ACCES/FR_CODE_ACCES_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Il ne vous reste plus qu’à télécharger et transmettre le document à votre client, ou le glisser dans votre dossier d’appel d’offre.'
  }]
};
